import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class CompanyConfigurationService extends BaseService {
    constructor() {
        super(apiroutes.COMPANY_CONFIGURATIONS);
    }

    /**
     * Get configurations by companyId and optional key filter
     * GET /api/restaurant/company-configurations?companyId=&page=0&limit=20&key=
     */
    async getConfigurations(companyId, key = '') {
        return await super.customCall('GET', '', null, {
            companyId,
            page: 0,
            limit: 20,
            key,
        }, null);
    }

    /**
     * Create a new configuration
     * POST /api/restaurant/company-configurations
     */
    async createConfiguration(data) {
        return await super.customCall('POST', '', data, null, 'json');
    }

    /**
     * Update an existing configuration by ID
     * PATCH /api/restaurant/company-configurations/:id
     */
    async updateConfiguration(id, data) {
        return await super.customCall('PATCH', `/${id}`, data, null, 'json');
    }
}

const CompanyConfigurationServices = new CompanyConfigurationService();
export default CompanyConfigurationServices;
